export const data = [
    {
        title: '协议确认',
        icon: require('./img/xy.png'),
        aIcon: require('./img/xy.png')
    },
    {
        title: '用户信息',
        icon: require('./img/bd.png'),
        aIcon: require('./img/bd1.png')
    },
    {
        title: '申请信息',
        icon: require('./img/SQ.png'),
        aIcon: require('./img/SQ1.png')
    },
    {
        title: '智能预审',
        icon: require('./img/cl.png'),
        aIcon: require('./img/cl1.png')
    },
    {
        title: '材料下载',
        icon: require('./img/ys.png'),
        aIcon: require('./img/ys1.png')
    },
    {
        title: '部门审核',
        icon: require('./img/sh1.png'),
        aIcon: require('./img/sh.png')
    },
    {
        title: '受理进度',
        icon: require('./img/bd.png'),
        aIcon: require('./img/bd1.png')
    }
];
